var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as React from 'react';
import Icon from '@datashop/icon';
import { styledComponents, theme } from '@datashop/theme';
var styled = styledComponents.default, withProps = styledComponents.withProps;
var Appearances;
(function (Appearances) {
    Appearances[Appearances["default"] = 0] = "default";
    Appearances[Appearances["information"] = 1] = "information";
    Appearances[Appearances["alert"] = 2] = "alert";
    Appearances[Appearances["success"] = 3] = "success";
    Appearances[Appearances["warning"] = 4] = "warning";
})(Appearances || (Appearances = {}));
var palette = theme.datashop.palette;
var appearanceColorMap = {
    default: palette.night.light,
    success: palette.green.main,
    warning: palette.yellow.main,
    alert: palette.red.main,
    information: palette.blue.main,
};
var iconMap = {
    default: '',
    success: 'check_circle',
    warning: 'warning',
    alert: 'report',
    information: 'info',
};
var Wrapper = withProps(styled.div)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-radius: 4px;\n  padding: 12px 24px 12px 16px;\n  position: relative;\n  overflow: hidden;\n  min-width: 256px;\n  box-sizing: border-box;\n\n  ", ";\n"], ["\n  border-radius: 4px;\n  padding: 12px 24px 12px 16px;\n  position: relative;\n  overflow: hidden;\n  min-width: 256px;\n  box-sizing: border-box;\n\n  ",
    ";\n"])), function (props) { return "\n    border: 1px solid " + props.theme.datashop.palette.stone.light + ";\n    border-top: 0;\n    box-shadow: " + (props.subdued ? "none" : "0 1px 2px 0 rgba(0, 0, 0, 0.12)") + ";\n  "; });
var BorderTop = withProps(styled.div)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: absolute;\n  height: 2px;\n  width: 100%;\n  left: 0;\n  top: 0;\n  background-color: ", ";\n"], ["\n  position: absolute;\n  height: 2px;\n  width: 100%;\n  left: 0;\n  top: 0;\n  background-color: ", ";\n"])), function (props) { return "" + appearanceColorMap[props.appearance]; });
var ContentWrapper = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n"], ["\n  display: flex;\n"])));
var IconWrapper = withProps(styled.div)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  > * {\n    ", "\n  }\n"], ["\n  > * {\n    ",
    "\n  }\n"])), function (props) { return "\n      color: " + appearanceColorMap[props.appearance] + ";\n      margin: " + (props.title ? '4px 16px 0 0' : '2px 16px 0 0') + ";\n    "; });
var Content = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  line-height: 20px;\n  width: calc(100% - 32px);\n\n  > * {\n    line-height: 20px;\n  }\n"], ["\n  line-height: 20px;\n  width: calc(100% - 32px);\n\n  > * {\n    line-height: 20px;\n  }\n"])));
var Title = styled.p(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  font-size: 16px;\n  margin: 0 0 8px;\n  font-weight: ", ";\n  line-height: 24px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n"], ["\n  font-size: 16px;\n  margin: 0 0 8px;\n  font-weight: ", ";\n  line-height: 24px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n"])), theme.datashop.weights.semibold);
var Message = (function (_super) {
    __extends(Message, _super);
    function Message() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Message.prototype.render = function () {
        var _a = this.props, title = _a.title, appearance = _a.appearance, children = _a.children, subdued = _a.subdued, rest = __rest(_a, ["title", "appearance", "children", "subdued"]);
        return (React.createElement(Wrapper, __assign({ subdued: subdued }, rest),
            React.createElement(BorderTop, { appearance: appearance }),
            React.createElement(ContentWrapper, null,
                appearance !== 'default' && (React.createElement(IconWrapper, { appearance: appearance, title: title },
                    React.createElement(Icon, { name: iconMap[appearance], style: { fontSize: '16px' } }))),
                React.createElement(Content, null,
                    title && React.createElement(Title, null, title),
                    children))));
    };
    Message.defaultProps = {
        appearance: 'default',
        subdued: false,
    };
    return Message;
}(React.Component));
export { Appearances };
export default Message;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
//# sourceMappingURL=Message.js.map